// extracted by mini-css-extract-plugin
export var footer = "_on-5";
export var fulfillmentInput = "_on-0";
export var shipDateInput = "_on-1";
export var shipmentModal = "_on-2";
export var shipmentModalContent = "_on-3";
export var tableContainer = "_on-4";